import { useContext } from 'react'
import { PushDrawerContext } from 'src/components/PushDrawer/pushDrawerContext'

export function usePushDrawer() {
    return useContext(PushDrawerContext)
}
